import React from 'react'
import Common_recharge_page_banner from '../../../common_components/common_banner/common_recharge_page_banner/Common_recharge_page_banner';
import Contribution from '../../../home/contribution/Contribution';
import { Form } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import * as animationData from '../../../animations/recharge_card_lottie_animation/Gas_Cylinder_animation.json';
import Select from 'react-select';
import Proceed_btn from '../../../common_components/common_btn/proceed_btn/Proceed_btn';
import Recharge_card_lottie_animation from '../../../animations/recharge_card_lottie_animation/Recharge_card_lottie_animation';
import All_providers from '../../../common_components/common_cards/all_providers/All_providers';
import Bill_payments from '../../../home/bill_payments/Bill_payments';
import Common_bill_payments from '../../../common_components/common_cards/common-bill-payments/Common_bill_payments';


function Gas_Cylinder() {

    const providers = [
        { id: 1, providerName: "Bharat Gas (BPCL)", logo: "/assets/images/services/all_providers/gas_cylinder/bharat-gas.png" },
        { id: 2, providerName: "Bharat Gas (BPCL)", logo: "/assets/images/services/all_providers/gas_cylinder/bharat-gas.png" },
        { id: 3, providerName: "Bharat Gas (BPCL)", logo: "/assets/images/services/all_providers/gas_cylinder/bharat-gas.png" },
        { id: 4, providerName: "Bharat Gas (BPCL)", logo: "/assets/images/services/all_providers/gas_cylinder/bharat-gas.png" },
        { id: 5, providerName: "Bharat Gas (BPCL)", logo: "/assets/images/services/all_providers/gas_cylinder/bharat-gas.png" },
        { id: 6, providerName: "Bharat Gas (BPCL)", logo: "/assets/images/services/all_providers/gas_cylinder/bharat-gas.png" },
    ];


    const navigate = useNavigate();

    const defaultOptions = {
        loop: true,
        autoplay: true,
        animationData: animationData,
        rendererSettings: {
            preserveAspectRatio: "xMidYMid slice"
        }
    };

    const services = [
        {
            id: 1,
            img: "/assets/images/home/bill_payments/money.png",
            title: "Mobile Recharge",
            baseLink: "/mobile-recharge",
        },
        {
            id: 2,
            img: "/assets/images/home/bill_payments/satellite-dish.png",
            title: "DTH Recharge",
            baseLink: "/dth-recharge",
        },
        {
            id: 3,
            img: "/assets/images/home/bill_payments/light-bulb.png",
            title: "Electricity Bill",
            baseLink: "/electricity-recharge",
        },
        {
            id: 5,
            img: "/assets/images/home/bill_payments/buy-a-car.png",
            title: "FASTag Recharges",
            baseLink: "/fastag-recharge",
        },
    ];

    const breadcrumbData = [
        { label: "Services", path: "/services", active: false },
        { label: "GAS CYLINDER", active: true }
    ];

    const options = [
        { value: 'airtel', label: 'Airtel DTH' },
        { value: 'tatasky', label: 'Tata Sky' },
        { value: 'dish', label: 'Dish TV' },
        { value: 'sun', label: 'Sun Direct' }
    ];
    return (
        <>
            <Common_recharge_page_banner
                title="GAS CYLINDER"
                breadcrumbItems={breadcrumbData}
            />
            <section className="Mobile_Recharge DTH_Recharge Electricity_Bill">
                <div className="container">
                    <div className="Mobile_Recharge_container">
                        <div className="row">
                            <div className="col-md-7">
                                {/* Left Side - Form */}
                                <div className="recharge_form_section form_box_section">
                                    <Form className="recharge_form">
                                        <div className="form_row">
                                            <div className="row">

                                                <div className="col-md-6">
                                                    <Form.Group controlId="rechargeAmount" className="form_field">
                                                        <Form.Label>Registered Contact Number/ LPG ID</Form.Label>
                                                        <Form.Control
                                                            type="text"
                                                            placeholder="Enter consumer number"
                                                        />
                                                        <Form.Text className="muted_text">
                                                            Please Enter Valid 17 Digit LPG ID
                                                        </Form.Text>
                                                    </Form.Group>
                                                </div>


                                                <div className="col-md-6">
                                                    <Form.Group controlId="operator" className="form_field">
                                                        <Form.Label>Provider Name</Form.Label>
                                                        <Select placeholder="Select Provider Name" options={options} />
                                                    </Form.Group>
                                                </div>

                                                <div className="col-12">
                                                    <div className="btn_holder">
                                                        <Proceed_btn
                                                            btnText="Continue"
                                                            className="save_changes_btn"
                                                            onClick={() => navigate("/gas-cylinder-recharge-details-plans")}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </Form>
                                </div>
                            </div>

                            <div className="col-md-5">
                                {/* Right Side - Cashback Section */}
                                <div className="cashback_offer_section form_box_section">
                                    <div className="cashback_box">
                                        <div className="heading_holder">
                                            <div className="cashback_heading">
                                                <h5>PAY YOUR GAS BILL  </h5>
                                                <h5>IN SECONDS</h5>
                                            </div>
                                            <span className="tnc_text">*T&C Apply</span>
                                        </div>
                                        <p>Get reminders & pay for your gas cylinder on time, every time.</p>
                                    </div>

                                    <div className="recharge_lottie_holder">
                                        <Recharge_card_lottie_animation defaultOptions={defaultOptions} />
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </section>


            <All_providers providers={providers}
                title="PIPED GAS PROVIDER"
                subtitle="Select your provider & enjoy quick, seamless recharges."
                showSearch={false}
                showStateName={false}
                showDivider={false} />
            <Bill_payments
                sectionTitle='EXPLORE OUR OTHER SERVICES'
                sectionSubtitle='From recharges to rewards, discover everything we offer in one place'
                services={services}
            />
            <Contribution />
        </>
    )
}

export default Gas_Cylinder